import { formatRelatedEntityCountLabel } from '@/features/metrics/components/statusMetricCards';
import { collapseExecutionStatusCounts } from '@/features/shared/utils/projectStatusPresentation';
import type { EntityStackedBarSeries } from '@/features/shared/components/entityTrends/EntityPageContent';
import type { StackedBarChartDatum } from '@/ui/primitives/StackedBarChart';

type StackedChartData<TSeries extends { key: string }> = {
  data: StackedBarChartDatum[];
  series: TSeries[];
};

export const collapseGroupedStackedChartData = <TSeries extends EntityStackedBarSeries>(
  stackedChartData: StackedChartData<TSeries> | null,
): StackedChartData<TSeries> | null => {
  if (stackedChartData === null) {
    return null;
  }

  return {
    ...stackedChartData,
    data: stackedChartData.data.map((datum) => {
      const collapsedCounts = collapseExecutionStatusCounts(
        {
          passed: typeof datum.passed === 'number' ? datum.passed : 0,
          failed: typeof datum.failed === 'number' ? datum.failed : 0,
          errored: typeof datum.errored === 'number' ? datum.errored : 0,
          skipped: typeof datum.skipped === 'number' ? datum.skipped : 0,
          untested: typeof datum.untested === 'number' ? datum.untested : 0,
        },
        true,
      );

      return {
        ...datum,
        ...collapsedCounts,
      };
    }),
    series: stackedChartData.series.filter((seriesItem) => seriesItem.key !== 'errored'),
  };
};

export const formatRelatedEntitySummaryTotalLabel = (
  relatedEntityTotal: number | undefined,
  metricsScope: 'suite' | 'test',
): string =>
  formatRelatedEntityCountLabel(relatedEntityTotal, metricsScope === 'suite' ? 'Suite' : 'Test');
